import { Observable } from 'rxjs';
import _ from 'lodash';
import { push } from 'connected-react-router/immutable';

import VolunteersApi from 'entities/volunteers/api';
import { selectVolunteerById } from 'entities/volunteers/selectors';
import { showMessageAction, showErrorAction } from 'containers/Notification/actions';

import { initSuccessAction, initFailedAction, submitFailedAction } from './actions';
import { INIT, SUBMIT_FAILED, SUBMIT_SUCCESS } from './constants';

const init = (action$, store) =>
  action$.ofType(INIT).exhaustMap(({ id }) => {
    const actions = [];
    const state = store.getState();
    const volunteer = selectVolunteerById(state, id);

    if (!volunteer) {
      actions.push(VolunteersApi.fetchById(id));
    }

    if (actions.length === 0) {
      return Observable.of(initSuccessAction());
    }

    return Observable.combineLatest(actions)
      .mergeMap((resultingActions) => [..._.flatten(resultingActions), initSuccessAction()])
      .catch((e) => Observable.of(initFailedAction(e)));
  });

const submitFailed = (action$) =>
  action$.ofType(SUBMIT_FAILED).exhaustMap(() => [showErrorAction('Saving Affiliation Failed')]);

const submitSuccess = (action$) =>
  action$
    .ofType(SUBMIT_SUCCESS)
    .exhaustMap(({ userId }) => [
      showMessageAction('Affiliation Created'),
      push(`/volunteers/${userId}`),
    ])
    .catch((error) => [submitFailedAction(error)]);

export default [init, submitFailed, submitSuccess];
